import moment from 'moment';

const DISCARDABLE_GPS_ODOMETER_VALUE_DISCONNECTION_THRESHOLD_IN_HOURS = 2;

const computeOdometer = ({ initialOdometer = 0, gpsOdometer = {}, gpsOdometerOnDisconnection = {} }) => {
  let gpsOdometerCurrentValue = gpsOdometer.value;

  if (gpsOdometerOnDisconnection.hasOwnProperty('updatedAt') && gpsOdometerOnDisconnection.updatedAt !== '' && moment(gpsOdometerOnDisconnection.updatedAt).isValid()) {
    const diff = moment(gpsOdometer.updatedAt).diff(moment(gpsOdometerOnDisconnection.updatedAt), 'hours');

    if (diff < DISCARDABLE_GPS_ODOMETER_VALUE_DISCONNECTION_THRESHOLD_IN_HOURS) {
      gpsOdometerCurrentValue = 0;
    }
  }
  return initialOdometer + gpsOdometerCurrentValue + (gpsOdometerOnDisconnection.value || 0);
};

export default { computeOdometer };



// WEBPACK FOOTER //
// ./src/helpers/odometerHelper.js